import { BaseError } from '@dynamic-labs-sdk/client';

type NoUTXOsFoundErrorParams = {
  address: string;
};

export class NoUTXOsFoundError extends BaseError {
  public readonly address: string;

  constructor({ address }: NoUTXOsFoundErrorParams) {
    super({
      cause: null,
      code: 'no_utxos_found_error',
      details: `Address: ${address}`,
      docsUrl: null,
      name: 'NoUTXOsFoundError',
      shortMessage: 'No UTXOs found for this address',
    });

    this.address = address;
  }
}
